"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function Skeleton(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "square" : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.width, width = _d === void 0 ? 32 : _d, className = _a.className, style = _a.style, children = _a.children;
    return (react_1.default.createElement(styles_1.Container, { className: className, style: style, variant: variant, height: height, width: width }, children));
}
exports.default = Skeleton;
//# sourceMappingURL=index.js.map